var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 86 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: "4px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9602 85.52L53.2402 85.38V84.96C53.1502 85.15 53.0602 85.34 52.9602 85.52Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9602 85.52L53.2402 85.38V84.96C53.1502 85.15 53.0602 85.34 52.9602 85.52Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2402 60.57V95.38C39.4502 96.76 44.6303 95.4 48.7903 91.3C48.9403 91.16 49.0802 91.01 49.2202 90.86C50.7002 89.31 51.9502 87.53 52.9602 85.52L53.2402 85.38V84.96C54.7402 81.79 55.6803 78.05 56.0803 73.76L53.2402 72.12L33.2402 60.57ZM33.2402 60.57L28.4202 57.79L10.4001 47.39C10.2701 46.5 10.2102 45.81 10.2102 45.29V22.49L22.5303 24.3L30.2102 25.43L33.2402 25.88V60.57ZM53.2402 36.68L33.2402 16.52L30.2102 16.07L22.5303 14.94L2.53027 12V38.88C2.53027 50.04 5.42021 61.86 11.2102 74.34C17.0002 86.83 24.3502 96.92 33.2402 104.63C40.2602 106.65 46.3101 106.07 51.4001 102.89H51.4102C52.7702 102.03 54.0503 101 55.2703 99.78C56.5103 98.54 57.6203 97.17 58.5803 95.68C60.5803 92.65 62.0104 89.11 62.8804 85.06C63.6004 81.81 63.9502 78.24 63.9502 74.34V47.47L53.2402 36.68Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4001 37.39L23.5903 40.79L10.4001 47.39C10.2701 46.5 10.2102 45.81 10.2102 45.29V22.49L22.5303 24.3L30.2102 25.43V35.29C30.2102 35.81 30.2701 36.5 30.4001 37.39Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2402 39.0299V60.5699L28.4202 57.7899L10.4001 47.3899L23.5903 40.7899L30.4001 37.3899L33.2402 39.0299Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9602 85.52C51.9502 87.53 50.7002 89.31 49.2202 90.86C49.0802 91.01 48.9403 91.16 48.7903 91.3C44.6303 95.4 39.4502 96.76 33.2402 95.38L46.9702 88.52L52.9602 85.52Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2402 72.1201V84.9601C53.1502 85.1501 53.0602 85.3401 52.9602 85.5201L46.9702 88.5201L33.2402 95.3801V60.5701L53.2402 72.1201Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2402 6.52L38.7803 13.75L33.2402 16.52L30.2102 16.07L22.5303 14.94L2.53027 12L22.5303 2L53.2402 6.52Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9502 37.47L63.9502 47.47L53.2402 36.68L33.2402 16.52L38.7803 13.75L53.2402 6.52002L83.9502 37.47Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9502 37.47V64.34C83.9502 75.5 81.0603 83.98 75.2703 89.78C73.3703 91.68 71.3003 93.14 69.0603 94.13L68.9702 94.17L51.4102 102.88C52.7702 102.03 54.0503 101 55.2703 99.78C56.5103 98.54 57.6203 97.17 58.5803 95.68C60.5803 92.65 62.0104 89.11 62.8804 85.06C63.6004 81.81 63.9502 78.24 63.9502 74.34V47.47L83.9502 37.47Z",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5002 93.9099L69.0603 94.1299",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4001 102.89L50.6104 103.28",
    stroke: "#5d8aa8",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.77d48088da32dfd94a8bc079436b6c09.svg";
export { ForwardRef as ReactComponent };